import React from "react";
import { useNavigate } from "react-router-dom";

import {
    Provider as CommanderProvider,
    CommanderFunction,
} from "../../contexts/commander";

import { queueCommander } from "./queue-commander";

type WithCommanderProps = {
    commander: (navigate: (path: string) => void) => CommanderFunction;
};

export const withCommanderContextProvider =
    <P extends WithCommanderProps>(Component: React.ComponentType<P>) =>
    (props: P) => {
        const { commander } = props;

        const nav = useNavigate();
        const navigate = (path: string) => nav(path);
        const queuedCommander = queueCommander(commander(navigate));

        return (
            <CommanderProvider value={queuedCommander}>
                <Component {...props} />
            </CommanderProvider>
        );
    };
